<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/E9KZlm/images/9781451605037_ci_std.jpg?1717896328177" alt="This image is the cover for the book Beyond the Storm"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beyond the Storm
      </h1>
      <p class="bookDescription body article font2">
        <b>This book is about surviving the storm.</b><br/><br/>One day the sun is shining, the winds are calm, and the water is smooth—then all of a sudden, a furious storm comes out of nowhere, and the waves break over you and knock you off your feet. Grasping for breath, you struggle to regain your senses. You turn your eyes to heaven in search of help—but sometimes you can't see the help, and sometimes you don't know if you're heard. <br/><br/>This book is written by and for storm travelers. To help you survive your storm, Jerry Jones freely shares his own hard-earned insights gained from his five-year ordeal of watching his wife die after a valiant struggle with cancer. Other storm travelers also share personal stories of death, terror, divorce, and illness. Together, these <i>Voices from the Storm</i> confirm that you are not alone in your heartache, and their struggles and victories assure you that there is a path that leads to the peaceful shore. The pages of this book will fill you with comfort and will empower you with strength and fortitude to survive and move beyond the storm.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jerry Jones
      </h2>
      
      <p class="authorDescription body article"><B>Dr. Jerry Jones</B> is a well-traveled and much-sought-after teacher of God's Word. He has two master degrees and a TH.D. from New Orleans Baptist Theological Seminary. He has taught at the undergraduate and graduate level. After the tragic death of his wife of thirty-five years, he met and married Lynn Thompson, who now travels with him all over the country. Together, they minister to hurting people who have felt the torrents of life's worst storms.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Howard Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?77377318